import { Center, Container, Loader, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { adminGetPlugins } from "../../api";

export default function AdminPluginList() {
  const [data, setData] = useState(null);
  const [, setLocation] = useLocation();

  useEffect(() => {
    adminGetPlugins().then((data) => {
      setData(data);
    });
  }, []);

  if (!data)
    return (
      <Center>
        <Loader mt="xl" size="xl" />
      </Center>
    );

  return (
    <Container>
      {/* <Button component={Link} to="styles/new">
        Add Style
      </Button> */}
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Hash</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((p) => (
            <Table.Tr
              key={p.hash}
              onClick={() => setLocation(`/admin/plugins/${p.hash}/options`)}
            >
              <Table.Td>{p.name}</Table.Td>
              <Table.Td>{p.hash}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
}
